import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button, SelectChangeEvent } from '@mui/material';
import { t } from 'i18next';

type MultiplePaymentDialogActionsProps = {
  transactionDate: Date | null;
  setTransactionDate: (date: Date | null) => void;
  paymentSource: string;
  setPaymentSource: (source: string) => void;
  isSubmitting: boolean;
  onHandleClose: () => void;
  errors: Record<string, any>;
  validSubmit: boolean;
};

export const MultiplePaymentDialogActions = (props: MultiplePaymentDialogActionsProps) => {
  const { transactionDate, setTransactionDate, paymentSource, setPaymentSource, isSubmitting, onHandleClose, errors, validSubmit } = props;

  const handleDateChange = (date: Date | null) => {
    setTransactionDate(date);
  };

  const handleSourceChange = (event: SelectChangeEvent<string>) => {
    setPaymentSource(event.target.value);
  };

  const isButtonDisabled = () => {
    return transactionDate === null || paymentSource.trim() === '' || Object.keys(errors).length > 0 || !validSubmit;
  };

  return (
    <Grid
      container
      spacing={2}
      justifyContent='flex-end'
      pr={1}
      sx={{
        pr: {
          sm: 4,
          md: 1,
        },
        overflowX: 'hidden',
      }}
    >
      <Grid item xs={12} sm={3} md={3}>
        <DatePicker
          format='YYYY-MM-DD'
          label={t('invoice:transactionPage.date')}
          onChange={handleDateChange}
          slots={{
            textField: (params) => <TextField {...params} size='small' InputLabelProps={{ shrink: true }} fullWidth />,
          }}
          value={transactionDate}
        />
      </Grid>

      <Grid item xs={12} sm={3} md={3} pr={3}>
        <FormControl fullWidth variant='outlined' size='small' sx={{ minHeight: '40px' }}>
          <InputLabel id='select-source-label'>{t('invoice:transactionPage.source.label')}</InputLabel>
          <Select
            required
            labelId='select-source-label'
            label={t('invoice:transactionPage.source.label')}
            value={paymentSource}
            onChange={handleSourceChange}
          >
            <MenuItem value='Bankgiro'>Bankgiro</MenuItem>
            <MenuItem value='Plusgiro'>Plusgiro</MenuItem>
            <MenuItem value='Kassa'>Kassa</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          pr: {
            sm: 8,
          },
        }}
      >
        <Button variant='outlined' color='primary' disableElevation onClick={onHandleClose} fullWidth>
          {t('common:button.cancel')}
        </Button>
      </Grid>
      <Grid item xs={12} sm={1}>
        <LoadingButton autoFocus loading={isSubmitting} variant='contained' type='submit' disableElevation fullWidth disabled={isButtonDisabled()}>
          {t('common:button.save')}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};
